import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-collapse-card',
  templateUrl: './collapse-card.component.html',
  styleUrls: ['./collapse-card.component.scss']
})
export class CollapseCardComponent implements OnInit {
  @Input() faqData: any;

  constructor() { }

  ngOnInit(): void {
  }

}
